import { render, staticRenderFns } from "./HomeNutrition.vue?vue&type=template&id=19a9e65b"
import script from "./HomeNutrition.vue?vue&type=script&lang=js"
export * from "./HomeNutrition.vue?vue&type=script&lang=js"
import style0 from "./HomeNutrition.vue?vue&type=style&index=0&id=19a9e65b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports